import type { ReactElement } from 'react';
import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { organisationUsersWithMarkReviewerRoleParams } from 'pages/marking/helpers/request-params.helpers';
import { useCustomerUsers } from 'services/assist-api/entities/customer-user/customer-users';
import type { ManageMarkingMark } from 'services/assist-api/entities/test-instance-response-mark/types';
import { useAuthCustomer } from 'services/providers/auth.hooks';
import { isInitialLoad } from 'utils/check-query-status';
import SetActiveReviewerForm from './set-active-reviewer-form';

type Props = {
  mark: ManageMarkingMark;
  isOpen: boolean;
  onClose: () => void;
};

export default function SetActiveReviewerModal({ mark, isOpen, onClose }: Props): ReactElement {
  const currentOrganisation = useAuthCustomer();

  // Get all organisation users who have a mark reviewer role.
  const organisationUsersQuery = useCustomerUsers(
    organisationUsersWithMarkReviewerRoleParams(currentOrganisation?.id),
    { enabled: !!currentOrganisation?.id }
  );

  const organisationUsers = organisationUsersQuery.data?.json || [];

  const isLoading = !currentOrganisation || isInitialLoad(organisationUsersQuery);

  return (
    <Modal isOpen={isOpen} size="lg">
      <ModalHeader toggle={onClose}>Set Active Reviewer</ModalHeader>
      <ModalBody>
        {!isLoading && !organisationUsersQuery.isError && (
          <SetActiveReviewerForm
            mark={mark}
            organisationUsers={organisationUsers}
            onClose={onClose}
          />
        )}
      </ModalBody>
    </Modal>
  );
}
